module.exports = __webpack_public_path__ + "img/main.5da6674.jpg";